import { render, staticRenderFns } from "./table-action-row.vue?vue&type=template&id=54081382&"
import script from "./table-action-row.vue?vue&type=script&lang=js&"
export * from "./table-action-row.vue?vue&type=script&lang=js&"
import style0 from "./table-action-row.vue?vue&type=style&index=0&id=54081382&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports